export default __webpack_public_path__ + "static/media/start-logo.fdafb8b0.gif";